module.exports = [{"type":"title","text":"2024-10-11"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位Websocket服務：‘訂單更新推送’增加ro字段(reduceOnly字段)"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-10-11.json
// module id = ss+C
// module chunks = 3